export default __webpack_public_path__ + "static/media/mobilegrid.05bb6b31.png";